import { Agent } from "@/types";
import { apiClient } from "./api";

export const agentsApi = {
  list: () =>
    apiClient
      .get<{ agents: Agent[] }>("/eval/api/agents")
      .then((data) => data.agents || []),
};
